import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV_LINKS = [
    { href: "#experience", label: "Experience" },
    { href: "#packages", label: "Weddings" },
    { href: "#stay", label: "Stay" },
    { href: "#tequila", label: "Tequila" },
    { href: "#gallery", label: "Gallery" },
    { href: "#faq", label: "FAQ" },
    { href: "#contact", label: "Visit" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header
            className="fixed top-0 inset-x-0 z-40 bg-background/80 backdrop-blur-md border-b border-border/60"
            data-testid="site-navbar"
        >
            <nav className="container-px h-20 flex items-center justify-between">
                <Link to="/" className="flex flex-col leading-tight" data-testid="brand-link">
                    <span className="font-serif text-2xl tracking-tight">López Hill</span>
                    <span className="overline text-[10px] tracking-[0.3em]">Spicewood · Texas</span>
                </Link>

                <ul className="hidden lg:flex items-center gap-10">
                    {NAV_LINKS.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                className="text-sm tracking-wide text-muted-foreground hover:text-foreground transition-colors duration-300"
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <a
                    href="#booking"
                    className="hidden lg:inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground hover:bg-[hsl(var(--primary-hover))] transition-all duration-300 text-sm tracking-wide"
                    data-testid="nav-book-btn"
                >
                    Book Your Wedding
                </a>

                <button
                    className="lg:hidden p-2"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    data-testid="mobile-menu-btn"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            <div
                className={cn(
                    "lg:hidden overflow-hidden transition-[max-height] duration-500 border-t border-border/60",
                    open ? "max-h-96" : "max-h-0",
                )}
            >
                <ul className="container-px py-6 flex flex-col gap-5">
                    {NAV_LINKS.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-base"
                                data-testid={`mobile-link-${l.label.toLowerCase()}`}
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a
                            href="#booking"
                            onClick={() => setOpen(false)}
                            className="inline-block mt-2 px-6 py-3 bg-primary text-primary-foreground text-sm"
                            data-testid="mobile-book-btn"
                        >
                            Book Your Wedding
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    );
}
